import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MOBILE_TABS } from '../../mobile/mobileNav';

/**
 * Shown when a phone lands on a screen the mobile build doesn't cover —
 * usually a deep link from a reminder email.
 *
 * It names the screen and offers the way back rather than just refusing:
 * a dead end with no exit is how people end up force-quitting the app.
 */
const DesktopOnly: React.FC<{ onLogout?: () => void }> = ({ onLogout }) => {
  const { pathname } = useLocation();
  // "/staff-management" -> "Staff Management"
  const screen = pathname
    .split('/')
    .filter(Boolean)[0]
    ?.split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

  return (
    <div className="flex flex-col items-center text-center px-2 pt-10">
      <div className="text-5xl mb-4" aria-hidden="true">
        🖥️
      </div>
      <h1 className="text-lg font-bold text-gray-900">
        {screen ? `${screen} is a desktop screen` : 'This is a desktop screen'}
      </h1>
      <p className="text-sm text-gray-500 mt-2 leading-relaxed max-w-xs">
        It's built around wide tables and side-by-side panels that don't fit a
        phone. Open it on a computer and it's waiting for you — nothing here is
        lost.
      </p>

      <div className="w-full max-w-xs mt-8 space-y-2">
        <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">
          On your phone you can
        </p>
        {MOBILE_TABS.map((tab) => (
          <Link
            key={tab.to}
            to={tab.to}
            className="flex items-center gap-3 w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <span className="text-lg" aria-hidden="true">
              {tab.icon}
            </span>
            <span>{tab.label}</span>
          </Link>
        ))}
      </div>

      {onLogout && (
        <button onClick={onLogout} className="mt-8 text-sm text-red-600 font-medium">
          Sign out
        </button>
      )}
    </div>
  );
};

export default DesktopOnly;
